import { Inject, Injectable, InjectionToken, Provider } from '@angular/core';
import { ListStateService } from '@modules/common/components/list/list-state.service';
import { SortBy } from '@modules/common/types/SortBy';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';
import { StateService } from '@modules/settings/services/state.service';
import { StateKey } from '@modules/settings/types/state-key';
import { type MessageFolder } from '../types/message-folder';
import { MessageFolderListSortField, MessageFoldersListState } from '../types/message-folders-list-state';

export interface MessageFolderListStateServiceConfig {
  stateKey?: StateKey;
  withAdvancedSearch?: boolean;
  defaultSort?: SortBy<MessageFolderListSortField>;
}

export const MessageFolderListStateServiceConfigToken = new InjectionToken<MessageFolderListStateServiceConfig>(
  'Configuration object for message folder list state service',
);

@Injectable()
export class MessageFolderListStateService extends ListStateService<
  MessageFolder,
  MessageFolderListSortField,
  MessageFoldersListState
> {
  declare public readonly state: MessageFoldersListState;

  constructor(
    stateService: StateService,
    advancedSearchService: AdvancedSearchService,
    @Inject(MessageFolderListStateServiceConfigToken) config: MessageFolderListStateServiceConfig,
  ) {
    super();

    this.state = new MessageFoldersListState({
      searchService: advancedSearchService,
      stateService: stateService,
      stateKey: config.stateKey,
      withAdvanced: config.withAdvancedSearch,
    });
  }

  public static providers(config: MessageFolderListStateServiceConfig = {}): Provider[] {
    return super.prepareProviders(MessageFolderListStateServiceConfigToken, config);
  }
}

declare module '@modules/settings/types/state' {
  export interface State {
    [StateKey.messagesFoldersListState]?: MessageFoldersListState;
    [StateKey.sidebarMessagesFoldersListState]?: MessageFoldersListState;
    [StateKey.messagesFoldersDPListState]?: MessageFoldersListState;
  }
}
